"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutputEventNode = void 0;
const BaseNode_1 = require("../../BaseNode");
const Schema = __importStar(require("./schema.json"));
const NODE_TYPE = 'OUTPUT-EVENT';
class OutputEventNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this._resolve = (params) => {
            var _a, _b, _c;
            // Basically, build an object out of all of our inputs and return it...
            const parts = (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.objectSchema) === null || _b === void 0 ? void 0 : _b.split('::');
            if (params.outputEvent === undefined || params.outputEvent === true) {
                return Object.assign(Object.assign(Object.assign({}, params), { aggregateType: (_c = this.config) === null || _c === void 0 ? void 0 : _c.aggregateType }), (parts && parts.length === 3 ? { version: +parts[2], type: parts[1] } : {}));
            }
            return null;
        };
        this._interfaceDefinition = Schema;
    }
    // we override the schema definition here so that we can provide it based on the selected value
    get interfaceDefinition() {
        var _a, _b, _c, _d, _e, _f;
        if (this.schemaLookup.getNextDefault && ((_a = this.config) === null || _a === void 0 ? void 0 : _a.objectSchema) === this.schemaLookup.getNextDefault(this.config.aggregateType)) {
            this.schemaLookup.createNewDefaultEvent(this.config.aggregateType);
        }
        //grab the available aggregate types if available
        const aggregateTypes = this.schemaLookup.getAggregates && this.schemaLookup.getAggregates();
        // grab the available event schemas
        const schemas = this.schemaLookup
            .getSchemas({ aggregateType: ((_b = this.config) === null || _b === void 0 ? void 0 : _b.aggregateType) ? (_c = this.config) === null || _c === void 0 ? void 0 : _c.aggregateType : 'unknown' })
            .filter((id) => !['DATA', 'STATE', 'METADATA', 'COMMAND_DATA'].includes(id.schemaId));
        let inputParams = {}; // This may make more sense eventually Schema.definitions.InputParams as JSONSchema6;
        if ((_d = this.config) === null || _d === void 0 ? void 0 : _d.objectSchema) {
            // we use this trick to get a full copy of the schema. This may end up being too slow, but let's try for now.
            const schemaParams = JSON.parse(JSON.stringify(this.schemaLookup.getSchema(this.config.objectSchema) || {}));
            inputParams = Object.assign({}, schemaParams);
            //we can only add this is the type is object
            if (inputParams.type === 'object') {
                if (((_f = (_e = this.config) === null || _e === void 0 ? void 0 : _e.objectSchema) === null || _f === void 0 ? void 0 : _f.split('::').length) === 3 && inputParams.properties) {
                    delete inputParams.properties['type']; //Type and version will be set by the config selection, so remove these propeties
                    delete inputParams.properties['version'];
                }
                inputParams.properties = Object.assign({ outputEvent: { type: 'boolean', description: 'Output Event?(default: true)' } }, (inputParams.properties ? inputParams.properties : {}));
            }
            // We need to remove the metadata section because this is populated by the command processor.
            //  Technically we could probably leave it, but I don't see enough value in it to confuse the mapper user
            if (inputParams.properties) {
                delete inputParams.properties.metadata;
            }
        }
        return Object.assign(Object.assign({}, Schema), { ConfigParams: {
                type: 'object',
                properties: {
                    aggregateType: {
                        description: 'Aggregate Type',
                        type: 'string',
                        enum: aggregateTypes || undefined,
                    },
                    objectSchema: {
                        description: 'Event Schema',
                        type: 'string',
                        oneOf: schemas.map(s => { return { title: s.schemaLabel, const: s.schemaId }; })
                    },
                },
            }, InputParams: inputParams });
    }
}
exports.OutputEventNode = OutputEventNode;
OutputEventNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Output Event',
    isIdempotent: true,
    primaryCategory: 'Object Creation',
};
//# sourceMappingURL=OutputEvent.js.map